import { ICommandBarItemProps, IContextualMenuItem } from "@fluentui/react";
import { useBoolean } from '@fluentui/react-hooks';
import { RouterParams } from "App";
import { RootState } from "app/store";
import CustomPanel from "components/controls/CustomPanel";
import { EViewType } from "global/Application";
import { BuildVisibilityScope } from "global/Visibility/GlobalVisibility";
import { useEffect, useMemo, useState } from "react";
import { ConnectedProps, connect, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import BlueRelationshipContext from "./BlueRelationshipContext";
import FeesAndPremiumProperties from "./FeesAndPremiumProperties";
import FeesGrid from "./FeesGrid";
import FlexibleFieldView, { EScopeType } from "./FlexibleFieldView";
import MonthlyRecurringFees from "./MonthlyRecurringFees";
import StopLossWizard from "./StopLossWizard";

interface IProps extends TComponentConnectedProps {
    // feesAndPremiums: FAM.IFeesAndPremiums;
}

const FeesAndPremium = (props: IProps) => {

    const disabled = props.state.status.viewType !== EViewType.Modify;

    const params = useParams<RouterParams>();

    const [propertiesIsOpen, setPropertiesIsOpen] = useState(false);

    const [stopLossWizardIsOpen, { setTrue: stopLossWizardOpen, setFalse: stopLossWizardClose }] = useBoolean(false);

    useEffect(() => {
        document.title = `Fees and Premium`;

        if (feesAndPremium?.name)
            document.title = `Fees and Premium | ${feesAndPremium?.name}`;
    }, []);

    const dispatch = useDispatch();

    const contextMenu = useMemo(() => {

        const items: ICommandBarItemProps[] = [];

        if (!disabled)
            items.push({
                key: 'feesAndPremiumsProperties',
                text: 'Properties',
                iconProps: { iconName: 'Settings' },
                onClick: () => setPropertiesIsOpen(true)
            });

        return { items: items, key: 'feesAndPremium' };
    }, [props.state.status.viewType]);

    const feesAndPremium = props.state?.data.json?.feesAndPremiums?.find(q => q.id === params.feesAndPremiumId);
    const categoryFeesPremiums = props.state.data.config.cache?.map_bcbs_config_category_named["Fees and Premiums"];

    const menuStopLoss: IContextualMenuItem[] = [];

    if (!disabled)
        menuStopLoss.push(
            {
                key: `stopLossManage`,
                name: 'Manage',
                icon: 'DocumentManagement',
                onClick: (event, item) => {
                    if (event?.stopPropagation)
                        event.stopPropagation();

                    stopLossWizardOpen();
                },
            }
        );

    const controlVisibility = BuildVisibilityScope(
        null,
        props.state.data.json,
        null,
        null
    );


    return (
        <BlueRelationshipContext contextMenu={contextMenu}>
            {feesAndPremium &&
                <>
                    <StopLossWizard
                        isOpen={stopLossWizardIsOpen}
                        onDismiss={stopLossWizardClose}
                        onCancel={stopLossWizardClose}
                        feesAndPremiums={feesAndPremium}
                        variant={'add-pick'}
                        onConfirm={(event) => {
              
                            stopLossWizardClose();
                        }}
                    />

                    <FeesAndPremiumProperties
                        isOpen={propertiesIsOpen}
                        onDismiss={() => setPropertiesIsOpen(false)}
                        data={{ feeAndPremium: feesAndPremium }}
                    />

                    {/* <CustomPanel title={"Summary"} canCollapse={true} defaultCollapsed={true} >
                        Flexible Attribute Model Place Holder (Fields)
                    </CustomPanel> */}

                    <CustomPanel title={"Attributes"} canCollapse={true} defaultCollapsed={false} >
                        <FlexibleFieldView
                            disabled={disabled}
                            fields={feesAndPremium.fields}
                            category={categoryFeesPremiums}
                            tiers={[]}
                            scope={feesAndPremium}
                            visibility={controlVisibility}
                            scopeType={EScopeType.feesAndPremium}
                        />
                    </CustomPanel>


                    <FeesGrid
                        disabled={disabled}
                        feesAndPremium={feesAndPremium}
                        creditHidden={true}
                    />

                    <MonthlyRecurringFees
                        feesAndPremium={feesAndPremium}
                    />
                </>
            }

        </BlueRelationshipContext>
    )
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(FeesAndPremium)